export const kBrevetExams = [
    {
        title: "Sujet 0 - 1",
        year: "2025",
        origin: "Métropole",
        url: "exams/sujet-zero-dnb-serie-generale-a.pdf"
    },
    {
        title: "Sujet 0 - 2",
        year: "2025",
        origin: "Métropole",
        url: "exams/sujet-zero-dnb-serie-generale-b.pdf"
    },
]